import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { useContext } from 'react';
import { GlobalContext } from 'providers/Global';
import { ModalType } from '../../utils/constants';
import { footerContainer, footerLink } from './styles';

const Footer = () => {
  const {
    connection: { accountId },
    openModal,
  } = useContext(GlobalContext);

  if (accountId) return null;

  return (
    <Box as="footer" sx={footerContainer}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
      >
        <Text fontSize="xs" color="blackAlpha.400">
          &copy; 2026 LimeChain
        </Text>
        <Flex gap={4}>
          <Button
            variant="unstyled"
            sx={footerLink}
            onClick={() => openModal(ModalType.AboutModal)}
          >
            About
          </Button>
          <Button
            variant="unstyled"
            sx={footerLink}
            onClick={() => openModal(ModalType.FAQDrawer)}
          >
            FAQ
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Footer;
